import { Redirect, Route, Switch } from 'react-router-dom';

import ClientRouter from '../ClientRouter';
import UserContextRoute from '../components/util/UserContextRoute';
import { loadable } from '../util/routeUtils';

const DisbursementFlow = loadable(() => import('../pages/DisbursementFlow'));
const DisbursementConfirmation = loadable(() => import('../pages/DisbursementFlow/Confirmation'));
const GiftTrackerYourGiftPage = loadable(() => import('../pages/GiftTracker/YourGifts'));
const GiftTrackerEmptyStateContainer = loadable(
  () => import('../pages/GiftTracker/EmptyState/GiftTrackerEmptyStateContainer')
);
const NoMatch = loadable(() => import('../pages/NoMatch/NoMatch'));

const GiftTrackerRoutes = () => (
  <ClientRouter>
    <Switch>
      <Redirect exact path="/registry/gift-tracker" to="/registry/gift-tracker/your-gifts" />
      <Redirect
        exact
        path="/registry/gift-tracker/manage-gifts"
        to="/registry/gift-tracker/your-gifts"
      />
      <UserContextRoute
        exact
        path="/registry/gift-tracker/disbursement"
        component={DisbursementFlow}
      />
      <UserContextRoute
        exact
        path="/registry/gift-tracker/disbursement/confirmation"
        component={DisbursementConfirmation}
      />
      <UserContextRoute
        auth
        exact
        hasRegistry
        path="/registry/gift-tracker/your-gifts"
        component={GiftTrackerYourGiftPage}
      />
      <Route
        exact
        path="/registry/gift-tracker/get-started"
        component={GiftTrackerEmptyStateContainer}
      />
      <Route component={NoMatch} />
    </Switch>
  </ClientRouter>
);

export default GiftTrackerRoutes;
